import React from "react";
import { useTranslation } from "react-i18next";
import "swiper/css";
import image2 from "../../assets/WhyEyouth/whyEyouth2.webp";
import image2EN from "../../assets/WhyEyouth/whyEyouth2EN.webp";
import image4 from "../../assets/WhyEyouth/whyEyouth4.webp";
import image4EN from "../../assets/WhyEyouth/whyEyouth4EN.webp";
import image5 from "../../assets/WhyEyouth/whyEyouth5.webp";
import image5EN from "../../assets/WhyEyouth/whyEyouth5EN.webp";
import image6EN from "../../assets/WhyEyouth/whyEyouth6EN.webp";
import image3 from "../../assets/WhyEyouth/whyEyouthAr1.png";
import image1 from "../../assets/WhyEyouth/whyEyouthAr2.png";
import image6 from "../../assets/WhyEyouth/whyEyouthAr3.png";
import image3EN from "../../assets/WhyEyouth/whyEyouthEn1.png";
import image1EN from "../../assets/WhyEyouth/whyEyouthEn2.png";
import line from "../../assets/line.webp";
import styles from "./whyEYouth.module.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

export default function WhyEYouth() {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div
        className={`container d-flex flex-column justify-content-around ${styles.MobileView}`}
        id="whyEyouth"
      >
        <div className={`${styles.WhyEYouth} `}>
          <div className={styles.firstDivWhy}>
            <h2
              style={{
                color: "#273C97",
                fontWeight: "bold",
                marginTop: "1rem",
              }}
            >
              {t("Why EYouth")}{" "}
            </h2>
            <LazyLoadImage
                    src={line}
                    alt="underline"
                    className={`${styles.lineWeb} ${styles.lineMobile} `}
                    // ref={imageRef}
                />
            <p className="text-center w-75" style={{ fontSize: "24.78px" }}>
              {t(
                "The first Arabic platform to offer high-quality educational programs in demanded specialties in the Arab job market"
              )}
            </p>
          </div>
        </div>
        <div>
          {/* <Swiper
            dir="rtl"
            spaceBetween={screenWidth < 768 ? 60 : 0}
            slidesPerView={screenWidth < 768 ? 1 : 2}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
            }}
            modules={[Autoplay, Pagination, Navigation]}
            className="mySwiper "
          > */}
          <div className={styles.imgContainer}>
            {/* <SwiperSlide className=" d-flex  justify-content-center w-50">
              <LazyLoadImage src={i18n.language === "ar" ? image1 : image1EN} alt="icon" />
            </SwiperSlide> */}

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image1 : image1EN} alt="icon" />

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image2 : image2EN} alt="icon" />

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image3 : image3EN} alt="icon" />

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image4 : image4EN} alt="icon" />

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image5 : image5EN} alt="icon" />

            <LazyLoadImage className="p-1" src={i18n.language === "ar" ? image6 : image6EN} alt="icon" />
          </div>
        </div>
      </div>
    </>
  );
}
